var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-8 h-4 overflow-hidden rounded-sm shrink-0 flex items-center justify-center",attrs:{"aria-label":_vm.$i18n.locale,"type":"button"},on:{"click":_vm.openCountryBar}},[_c('img',{staticClass:"inline-block h-full w-auto",attrs:{"src":`/flags/${_vm.currentLocale}.svg`,"alt":_vm.currentLocale}})])
}
var staticRenderFns = []

export { render, staticRenderFns }